import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createTextVNode as _createTextVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "py-3 container-fluid space-y-4" }
const _hoisted_2 = { class: "bg-white rounded-xl shadow-md p-3" }
const _hoisted_3 = { class: "flex flex-col md:flex-row md:items-center gap-3" }
const _hoisted_4 = { class: "flex items-center gap-3 w-full" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "flex flex-col" }
const _hoisted_7 = { class: "text-xl font-bold mb-1 text-slate-800" }
const _hoisted_8 = { class: "mb-0 text-xs text-slate-500" }
const _hoisted_9 = { class: "bg-white rounded-xl shadow-md" }
const _hoisted_10 = { class: "p-3 mb-2 space-y-4" }
const _hoisted_11 = { class: "text-lg font-bold text-slate-800" }
const _hoisted_12 = {
  key: 0,
  class: "py-4 text-center text-lg md:text-2xl mx-auto"
}
const _hoisted_13 = { class: "divide-y divide-gray-200 list-none pb-4" }
const _hoisted_14 = ["onClick"]
const _hoisted_15 = { class: "flex items-center gap-3 py-2 mx-3" }
const _hoisted_16 = { class: "flex-1 text-left" }
const _hoisted_17 = { class: "text-sm md:text-lg font-semibold" }
const _hoisted_18 = { class: "text-sm text-gray-500 line-clamp-2" }
const _hoisted_19 = { class: "relative" }
const _hoisted_20 = { class: "p-2 text-gray-500" }
const _hoisted_21 = { class: "w-full flex flex-col md:flex-row md:w-auto gap-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NavPill = _resolveComponent("NavPill")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_NuevoBloqueoView = _resolveComponent("NuevoBloqueoView")!
  const _component_FullScreenLoader = _resolveComponent("FullScreenLoader")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("img", {
              src: _ctx.acreditado && _ctx.acreditado.foto ? _ctx.acreditado.foto : require('@/assets/img/nologo.png'),
              class: "shadow-sm w-16 rounded-lg"
            }, null, 8, _hoisted_5),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("h5", _hoisted_7, _toDisplayString(_ctx.acreditado ? _ctx.acreditado.nombre + " " + _ctx.acreditado.apellido : _ctx.$t('label.cargando')), 1),
              _createElementVNode("p", _hoisted_8, "Fecha de alta : " + _toDisplayString(_ctx.acreditado ? _ctx.formatDate(_ctx.acreditado.fechaAlta, 'dd/MM/yyyy HH:mm:ss') : _ctx.$t('label.cargando')), 1)
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("h6", _hoisted_11, _toDisplayString(_ctx.$t('menu.bloquear.horario')), 1),
          _createVNode(_component_NavPill, {
            items: _ctx.fechas,
            modelValue: _ctx.fechaSeleccionada,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.fechaSeleccionada) = $event)),
            onChange: _ctx.onChangeFechaCronograma
          }, null, 8, ["items", "modelValue", "onChange"])
        ]),
        (!_ctx.isSubmitting && _ctx.detalleAgenda.length == 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString(_ctx.$t('label.sin.restricciones.para')) + _toDisplayString(_ctx.fechaSeleccionada), 1))
          : _createCommentVNode("", true),
        _createElementVNode("ul", _hoisted_13, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.detalleAgenda, (item, i) => {
            return _withDirectives((_openBlock(), _createElementBlock("li", {
              key: i,
              onClick: ($event: any) => (_ctx.desbloquear(item.idAgenda)),
              class: "hover:bg-gradient-to-r from-gray-200 to-gray-50 cursor-pointer"
            }, [
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("div", {
                  class: "h-14 w-14 rounded-lg shadow flex items-center justify-center border",
                  style: _normalizeStyle({ borderColor: item.colorEstado, color: item.colorEstado })
                }, [
                  _createVNode(_component_font_awesome_icon, {
                    icon: ['fas', 'fa-lock'],
                    class: "text-3xl"
                  })
                ], 4),
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("div", _hoisted_17, _toDisplayString(item.cronograma.horaDesde), 1),
                  _createElementVNode("div", _hoisted_18, _toDisplayString(item.observaciones), 1)
                ]),
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("button", _hoisted_20, [
                    _createVNode(_component_font_awesome_icon, {
                      icon: ['fas', 'fa-unlock'],
                      class: "text-2xl mr-2 text-gray-500"
                    })
                  ])
                ])
              ])
            ], 8, _hoisted_14)), [
              [
                _directive_tooltip,
                'Eliminar bloqueo',
                void 0,
                { top: true }
              ]
            ])
          }), 128))
        ])
      ]),
      _createElementVNode("div", _hoisted_21, [
        _createElementVNode("button", {
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.mostrarNuevoBloqueo && _ctx.mostrarNuevoBloqueo(...args))),
          class: "w-full md:w-auto text-sm px-5 font-bold text-white py-3 bg-gradient-to-r from-[#424c42] to-[#bbc1a9] shadow-md rounded-xl transform transition-transform duration-200 hover:scale-105 active:scale-95"
        }, [
          _createVNode(_component_font_awesome_icon, {
            icon: ['fas', 'fa-lock'],
            class: "mr-2"
          }),
          _createTextVNode(" " + _toDisplayString(_ctx.$t('boton.cargar.bloqueo')), 1)
        ]),
        _createElementVNode("button", {
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.bloquearDiaCompleto && _ctx.bloquearDiaCompleto(...args))),
          class: "w-full md:w-auto text-sm px-5 font-bold text-white py-3 bg-gradient-to-r from-[#424c42] to-[#bbc1a9] shadow-md rounded-xl transform transition-transform duration-200 hover:scale-105 active:scale-95"
        }, [
          _createVNode(_component_font_awesome_icon, {
            icon: ['fas', 'fa-calendar-xmark'],
            class: "mr-2"
          }),
          _createTextVNode(" " + _toDisplayString(_ctx.$t('boton.bloqueo.dia')), 1)
        ])
      ])
    ]),
    (_ctx.nuevoBloqueoVisible)
      ? (_openBlock(), _createBlock(_component_NuevoBloqueoView, {
          key: 0,
          closeFunction: _ctx.closeDialogBloqueo,
          fechaBloqueo: _ctx.fechaSeleccionada
        }, null, 8, ["closeFunction", "fechaBloqueo"]))
      : _createCommentVNode("", true),
    _createVNode(_component_FullScreenLoader, { visible: _ctx.isSubmitting }, null, 8, ["visible"])
  ], 64))
}